export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10383.bbaaeeb3.jpg";